<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
    bottom
    left
    :max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to delete <b>{{ document.file_name.toUpperCase() }}</b> ? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      document: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.announcementDocuments().destroy(this.document.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted', this.document)
              this.$snack({ message: response.data.status })
            }
          })
          .catch({})
          .then(() => {
            this.menu = false
            this.progressing = false
          })    
      },
    },
  }
</script>
